if (window.ExternalDeal == null) {
  window.ExternalDeal = {};
}

ExternalDeal.init = function(arg, done) {
  var externalDeal;
  externalDeal = arg.externalDeal;
  if (!externalDeal) {
    return done();
  }
  return $(function() {
    var $externalBuyButton;
    $externalBuyButton = $('.external-buy');
    $externalBuyButton.click(function(e) {
      e.preventDefault();
      window.open($(this).attr('href'));
      return setTimeout(GIG.Modal.close, 3000);
    });
    return done();
  });
};

module.exports = ExternalDeal;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9leHRlcm5hbF9kZWFsL2Zyb250ZW5kL2V4dGVybmFsX2RlYWwuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvbW9kdWxlcy9leHRlcm5hbF9kZWFsL2Zyb250ZW5kL2V4dGVybmFsX2RlYWwuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7RUFBQSxNQUFNLENBQUMsZUFBZ0I7OztBQUV2QixZQUFZLENBQUMsSUFBYixHQUFvQixTQUFDLEdBQUQsRUFBaUIsSUFBakI7QUFDbEIsTUFBQTtFQURvQixlQUFEO0VBQ25CLElBQUEsQ0FBcUIsWUFBckI7QUFBQSxXQUFPLElBQUEsQ0FBQSxFQUFQOztTQUVBLENBQUEsQ0FBRSxTQUFBO0FBQ0EsUUFBQTtJQUFBLGtCQUFBLEdBQXFCLENBQUEsQ0FBRSxlQUFGO0lBQ3JCLGtCQUFrQixDQUFDLEtBQW5CLENBQXlCLFNBQUMsQ0FBRDtNQUN2QixDQUFDLENBQUMsY0FBRixDQUFBO01BQ0EsTUFBTSxDQUFDLElBQVAsQ0FBWSxDQUFBLENBQUUsSUFBRixDQUFPLENBQUMsSUFBUixDQUFhLE1BQWIsQ0FBWjthQUNBLFVBQUEsQ0FBVyxHQUFHLENBQUMsS0FBSyxDQUFDLEtBQXJCLEVBQTRCLElBQTVCO0lBSHVCLENBQXpCO1dBS0EsSUFBQSxDQUFBO0VBUEEsQ0FBRjtBQUhrQjs7QUFhcEIsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
